// removed by extract-text-webpack-plugin
module.exports = {"cwShell":"CwShell-cwShell"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwshell/CwShell.scss
// module id = 385
// module chunks = 0